var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 19.4248C4.06667 19.5581 3.75 19.5288 3.45 19.3368C3.15 19.1455 3 18.8665 3 18.4998V14.7748C3 14.5415 3.06667 14.3331 3.2 14.1498C3.33333 13.9665 3.51667 13.8498 3.75 13.7998L11 11.9998L3.75 10.1998C3.51667 10.1498 3.33333 10.0331 3.2 9.84981C3.06667 9.66648 3 9.45814 3 9.22481V5.49981C3 5.13314 3.15 4.85381 3.45 4.66181C3.75 4.47048 4.06667 4.44148 4.4 4.57481L19.8 11.0748C20.2167 11.2581 20.425 11.5665 20.425 11.9998C20.425 12.4331 20.2167 12.7415 19.8 12.9248L4.4 19.4248Z",
    fill: "#2D5FE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSend);
export default __webpack_public_path__ + "static/media/ico-send.502a6875a8bbdd910d2455cba48959b1.svg";
export { ForwardRef as ReactComponent };